module.exports = __webpack_public_path__ + "static/media/pic2.c36737d1.jpg";